export default __webpack_public_path__ + "static/media/noword.aa8b9656.PNG";